module.exports = __webpack_public_path__ + "img/foot-logo.9e8d96f8.svg";